export default __webpack_public_path__ + "static/media/successful-check-mark.be26ffbf.svg";